import {
  ThemeIcon as MantineThemeIcon,
  ThemeIconProps as MantineThemeIconProps,
} from '@mantine/core';

import styles from './ThemeIcon.module.css';

export type ThemeIconSize = '20' | '24' | '32' | '36' | '40' | '48';

export type ThemeIconColor =
  | 'default'
  | 'gray'
  | 'indigo'
  | 'blue'
  | 'green'
  | 'mint'
  | 'yellow'
  | 'orange'
  | 'pink'
  | 'red'
  | 'none';

export interface ThemeIconProps extends Omit<
  MantineThemeIconProps,
  | 'variant'
  | 'color'
  | 'styles'
  | 'classNames'
  | 'style'
  | 'size'
  | 'radius'
  | 'gradient'
  | 'autoContrast'
> {
  /** Container size in pixels: 20, 24, 32, 40, 48. Default: 48 */
  size?: ThemeIconSize;
  width?: ThemeIconSize;
  height?: ThemeIconSize;
  /** Color variant. Default: default */
  color?: ThemeIconColor;
}

export const ThemeIcon = ({
  size = '24',
  color = 'default',
  children,
  width,
  height,
  ...props
}: ThemeIconProps) => {
  return (
    <MantineThemeIcon
      unstyled
      classNames={{ root: styles.root }}
      data-size={size}
      data-width={width ?? size}
      data-height={height ?? size}
      data-color={color}
      {...props}
    >
      {children}
    </MantineThemeIcon>
  );
};
